import { apiClient } from "@/lib/api/client";

export type OrganizationLocationRecordDto = {
  id: string;
  organization_id: string;
  tenant_id: string | null;
  name: string;
  address_line_1: string | null;
  address_line_2: string | null;
  city: string | null;
  state_id: string | null;
  state_name: string | null;
  state_code: string | null;
  pincode: string | null;
  latitude: number | null;
  longitude: number | null;
  is_primary: boolean;
  note: string | null;
  created_at: string;
  updated_at: string;
};

export type OrganizationLocationsListResponse = {
  items: OrganizationLocationRecordDto[];
  total: number;
};

export type OrganizationLocationCreateBody = {
  name: string;
  address_line_1: string;
  address_line_2?: string | null;
  city: string;
  state_id: string;
  pincode: string;
  latitude?: number | null;
  longitude?: number | null;
  is_primary?: boolean;
  note?: string | null;
};

export type OrganizationLocationUpdateBody = Partial<OrganizationLocationCreateBody>;

export async function listOrganizationLocations(
  organizationId: string,
): Promise<OrganizationLocationsListResponse> {
  const { data } = await apiClient.get<OrganizationLocationsListResponse>(
    `/organizations/${organizationId}/locations`,
  );
  return data;
}

export async function createOrganizationLocation(
  organizationId: string,
  body: OrganizationLocationCreateBody,
): Promise<OrganizationLocationRecordDto> {
  const { data } = await apiClient.post<OrganizationLocationRecordDto>(
    `/organizations/${organizationId}/locations`,
    body,
  );
  return data;
}

export async function updateOrganizationLocation(
  organizationId: string,
  locationId: string,
  body: OrganizationLocationUpdateBody,
): Promise<OrganizationLocationRecordDto> {
  const { data } = await apiClient.put<OrganizationLocationRecordDto>(
    `/organizations/${organizationId}/locations/${locationId}`,
    body,
  );
  return data;
}

export async function deleteOrganizationLocation(
  organizationId: string,
  locationId: string,
): Promise<void> {
  await apiClient.delete(`/organizations/${organizationId}/locations/${locationId}`);
}
